<template>
    <ModalBase
        :name="modalName"
        :title="'Etiqueta ' + etiqueta.name"
        @close="emitClose"
    >
        <h4 class="tw:pb-4 tw:text-center">Editar la etiqueta: {{ etiqueta.name }}</h4>
        <EtiquetaForm
            :etiqueta="tempTag"
            @terminado="edit"
        />
    </ModalBase>
</template>

<script setup>
    import { ref, computed, watch } from 'vue';
    import ModalBase from '@/modules/admin/ui/ModalBase.vue';
    import EtiquetaForm from '@/modules/admin/etiquetas/components/EtiquetaForm.vue';

    const props = defineProps({
        etiqueta: {
            type: Object,
            default: () => ({})
        }
    });

    const emit = defineEmits(['close', 'update']);

    const tempTag = ref({ ...props.etiqueta });

    const modalName = computed(() => 'editar-' + (tempTag.value.id || props.etiqueta?.id || ''));

    watch(() => props.etiqueta, newVal => {
        tempTag.value = { ...newVal };
    }, { deep: true });

    function emitClose() {
        emit('close', modalName.value);
    }

    function edit(formData) {
        Object.assign(tempTag.value, formData);
        emit('update', tempTag.value);
    }
</script>
